import {FC} from 'react'
import {Modal} from '@components/ui/modal/Modal.tsx'
import {XCloseIcon} from '@components/ui/icon/Icon.tsx'
import {
    StyledConfirmModalBody,
    StyledConfirmModalCloseButton,
    StyledConfirmModalContent,
    StyledConfirmModalFooter,
    StyledConfirmModalHeader
} from '@components/commons/confirm-modal/style.ts'
import {Button, ButtonStyleProps} from '@components/ui/button/Button.tsx'
import {useTranslation} from 'react-i18next'
import {Spinner} from '@components/ui/spinner/Spinner.tsx'

interface ConfirmModalProps {
    modalTitle: string
    title: string
    description?: string
    onClose: () => void
    primaryCtaLabel: string
    onClickCta: () => void
    isPending: boolean
    ctaVariant?: ButtonStyleProps['variant']
}
export const ConfirmModal: FC<ConfirmModalProps> = ({
    modalTitle,
    title,
    description,
    onClose,
    onClickCta,
    primaryCtaLabel,
    isPending,
    ctaVariant
}) => {
    const {t} = useTranslation()
    return (
        <Modal onOverlayClick={onClose} width={444}>
            <StyledConfirmModalContent>
                <StyledConfirmModalHeader justify={'center'}>
                    <StyledConfirmModalCloseButton $size={'sm'} $variant={'ghost'} onClick={onClose}>
                        <XCloseIcon />
                    </StyledConfirmModalCloseButton>
                    <p>{modalTitle}</p>
                </StyledConfirmModalHeader>
                <StyledConfirmModalBody direction={'column'} gap={2}>
                    <h4>{title}</h4>
                    {description && <p>{description}</p>}
                </StyledConfirmModalBody>
                <StyledConfirmModalFooter justify={'space-between'}>
                    <Button variant={'ghost'} onClick={onClose} disabled={isPending}>
                        {t('commons:cancel')}
                    </Button>
                    <Button variant={ctaVariant} onClick={onClickCta} disabled={isPending}>
                        {primaryCtaLabel}
                        {isPending && <Spinner size={24} />}
                    </Button>
                </StyledConfirmModalFooter>
            </StyledConfirmModalContent>
        </Modal>
    )
}
